import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16ZM12 6.5C9.99797 6.5 8.375 8.12297 8.375 10.125C8.375 10.6773 8.82272 11.125 9.375 11.125C9.92728 11.125 10.375 10.6773 10.375 10.125C10.375 9.22754 11.1025 8.5 12 8.5C12.8975 8.5 13.625 9.22754 13.625 10.125C13.625 10.8073 13.2042 11.3937 12.6042 11.6343C11.9293 11.9048 11 12.5971 11 13.75V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14C13 13.7563 13.0494 13.6339 13.2612 13.5293L13.3484 13.4907C14.681 12.9564 15.625 11.6522 15.625 10.125C15.625 8.12297 14.002 6.5 12 6.5Z" })
});
export default SvgQuestionFill;
